import { apiMaybe } from '../../services/apiClient';

export function buildRequestSearchQuery({ q, limit } = {}) {
  const params = new URLSearchParams();
  if (q != null && String(q).trim() !== '') params.set('q', String(q).trim());
  if (limit) {
    params.set('page', '1');
    params.set('pageSize', String(limit));
  }
  return params.toString();
}

/**
 * Quick-find over TPRM requests (used by ⌘K). Reuses the list endpoint's `q`
 * filter — vendor name/website/contact/email, Lightspark entity, service
 * owner, requester name/email. The backend already scopes results to the
 * caller's own requests unless they have elevated access, so callers don't
 * need any extra gating.
 */
export function searchRequests(params = {}) {
  const query = buildRequestSearchQuery(params);
  return apiMaybe(`/requests${query ? `?${query}` : ''}`);
}
